import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [IonicModule, CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent{

  @Input() disabled:boolean = false
  @Input() submit:boolean = false
  @Input() text: string = ''
  @Input() extraStyle: string = ''
  @Input() extraClass: string = ''
  @Input() styleType: 'primary' | 'primary-flat' | 'secondary' = 'primary'
  @Input() function!: Function
  @Input() fullWidth: boolean = false
  @Input() loading: boolean = false


  onClick(): void {
    if (this.function && !this.submit) {
      this.function();
    }
  }
}
